/* 🤖 this file was generated by svg-to-ts */
export const matIconTextsms: {
  name: 'textsms';
  data: string;
} = {
  name: 'textsms',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H6l-2 2V4h16v12zM7 9h2v2H7zm4 0h2v2h-2zm4 0h2v2h-2z"/></svg>`
};
